import { render } from "./DashboardsCalendar.vue?vue&type=template&id=3d410df2&scoped=true&ts=true"
import script from "./DashboardsCalendar.vue?vue&type=script&lang=ts"
export * from "./DashboardsCalendar.vue?vue&type=script&lang=ts"

import "./DashboardsCalendar.vue?vue&type=style&index=0&id=3d410df2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d410df2"]])

export default __exports__